import Image from "next/image";
import Link from "next/link";
import { useTranslation } from "react-i18next";

import logo from "@/public/images/logo/smarttech-full-blue.png";
import logoLight from "@/public/images/logo/smarttech-full-white.png";

import FooterData from "@/data/footer.json";
import SingleFooter from "./sections/SingleFooter";
import CopyRight from "./sections/CopyRight";
import { useAppContext } from "@/context/Context";

// CONFIGS AND ROUTE
import { ROUTE } from "@/route/app_routes.js";
import { CONFIG } from "@/app_config.js";



const Footer = ({bg="white"}) => {

  const { isLightTheme } = useAppContext();
  const useLightLogo = bg === "dark" || !isLightTheme;
  const { t } = useTranslation();

  return (
    <>
      <footer className={`rbt-footer rbt-footer-shadow-1 footer-style-1 bg-color-${bg} overflow-hidden`}>
        <div className="gradient-shadow-top"></div>
        <div className="gradient-shadow-bottom"></div>
        <div className="footer-top">
          <div className="container">
            {FooterData &&
              FooterData.footerOne.map((footer, index) => (
                <div className="row row--15 mt_dec--30" key={index}>


                  <div className="col-lg-4 col-md-6 col-sm-6 col-12 mt--30">
                    <div className="footer-widget">
                      <div className="logo">
                        <Link href={ ROUTE.home }>
                          {useLightLogo ? (
                            <Image src={logoLight} width={158} height={60} priority={true} alt={t("footer.logoAlt")} />
                          ) : (
                            <Image src={logo} width={158} height={60} priority={true} alt={t("footer.logoAlt")} />
                          )}
                        </Link>
                      </div>

                      <p className="description mt--20">{t("footer.description", { appName: CONFIG.APP_NAME })}</p>

                      <div className="contact-btn mt--30">
                        <Link className="rbt-btn hover-icon-reverse btn-border-gradient radius-round" href={ ROUTE.contact }>
                          <div className="icon-reverse-wrapper">
                            <span className="btn-text">{t("footer.contactWithUs")}</span>
                            <span className="btn-icon">
                              <i className="feather-arrow-right"></i>
                            </span>
                            <span className="btn-icon">
                              <i className="feather-arrow-right"></i>
                            </span>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>



                  <SingleFooter classOne="offset-lg-1 col-lg-2 col-md-6 col-sm-6 col-12 mt--30" title={t("footer.companyHeading")} data={[ { text: t("footer.links.home"), link: ROUTE.home },
                    { text: t("footer.links.about"), link: ROUTE.about }, { text: t("footer.links.courses"), link: ROUTE.course },
                    { text: t("footer.links.events"), link: ROUTE.events }, { text: t("footer.links.blog"), link: ROUTE.blog }, { text: t("footer.links.contactUs"), link: ROUTE.contact }, { text: t("footer.links.register"), link: ROUTE.register },
                    { text: t("footer.links.login"), link: ROUTE.login } ]} />




                  <SingleFooter classOne="col-lg-2 col-md-6 col-sm-6 col-12 mt--30" title={t("footer.resourcesHeading")} data={[ { text: t("footer.links.faq"), link: ROUTE.faq },
                    { text: t("footer.links.termsOfUse"), link: ROUTE.terms }, { text: t("footer.links.privacyPolicy"), link: ROUTE.privacy },
                    { text: t("footer.links.verifyCertificate"), link: ROUTE.certificateVerify } ]} />




                  <div className="col-lg-3 col-md-6 col-sm-6 col-12 mt--30">
                    <div className="footer-widget">
                      <h3 className="ft-title">{t("footer.contactHeading")}</h3>
                      <ul className="ft-link">
                        <li>
                          <span>{t("footer.emailLabel")}</span>{" "}
                          <Link href={"mailto:"+CONFIG.EMAIL_1}> { CONFIG.EMAIL_1 } </Link>
                        </li>
                      </ul>

                      <ul className="social-icon social-default icon-naked justify-content-start mt--20">
                        <li key={"1"}> <Link href={ROUTE.FACEBOOK} aria-label="Facebook"> <i className={"feather-facebook"}></i> </Link> </li>
                        <li key={"2"}> <Link href={ROUTE.TWITTER} aria-label="Twitter"> <i className={"feather-twitter"}></i> </Link> </li>
                        <li key={"3"}> <Link href={ROUTE.INSTAGRAM} aria-label="Instagram"> <i className={"feather-instagram"}></i> </Link> </li>
                        <li key={"4"}> <Link href={ROUTE.LINKEDIN} aria-label="LinkedIn"> <i className={"feather-linkedin"}></i> </Link> </li>
                        <li key={"5"}> <Link href={ROUTE.YOUTUBE} aria-label="YouTube"> <i className={"feather-youtube"}></i> </Link> </li>
                      </ul>
                    </div>
                  </div>

                  
                </div>
              ))}
          </div>
        </div>

        <CopyRight />
      </footer>

    </>
  );
};

export default Footer;
